import { WrenchTheme } from '@wds/styles';
import 'react';
import { createUseStyles } from 'react-jss'; // eslint-disable-next-line @typescript-eslint/naming-convention

const Theme = { ...WrenchTheme,
  // Add any additional question-related styles here
  keyline: {
    borderColor: WrenchTheme.semanticColor.muted,
    borderStyle: 'solid',
    borderWidth: '1px'
  }
};
const prefix = 'smq-';
const selectors = [`[class*='${prefix}']`, `[class*='${prefix}']::before`, `[class*='${prefix}']::after`];
createUseStyles(theme => {
  const {
    fontFamily
  } = theme;
  const resetStyles = {
    '-webkit-font-smoothing': 'antialiased',
    boxSizing: 'border-box',
    fontFamily: fontFamily.base,
    listStyle: 'none',
    margin: 0,
    padding: 0
  };
  return {
    '@global': {
      [selectors.join(',')]: resetStyles
    }
  };
}, {
  // Ensure this gets added to as the first stylesheet
  // ref: https://github.com/cssinjs/jss/blob/master/packages/react-jss/src/utils/getSheetIndex.js#L3-L16
  index: (Number.MIN_SAFE_INTEGER || -1e9) - 1,
  name: 'smquestions-global-styles'
});
export { Theme as T };